import React, {useState, useRef, useEffect} from 'react';
import DetailBoxCompany from './DetailBoxCompany/DetailBoxCompany';
import BenefitsBoxCompany from './DetailBoxLargeCompany/BenefitsBoxCompany';
import DetailDeepBoxCompany from './DetailDeepBoxCompany/DetailDeepBoxCompany';
import Locations from './Locations/Locations';
import ProfileCompanyHeader from './ProfileCompanyHeader/ProfileCompanyHeader';
import Offers from './Offers/Offers';
import useFetchCompanyProfile from '../../../hooks/company/useFetchCompanyProfile';
import { useParams, useLocation } from 'react-router-dom';
import './companyProfile.css';
import LocationMap from '../../Shared/Map/LocationMap';
import PhotoGallery from './PhotoGallery/PhotoGallery';
import Loading from '../../Shared/Loading/Loading';
import Reviews from '../../Employee/EmployeeDetailView/Reviews/Reviews';
import useFetchRestaurantReviews from '../../../hooks/reviews/useFetchRestaurantReviews';

const CompanyProfile = () => {
  const [flashMessage, setFlashMessage] = useState('')
  const { id } = useParams(); 
  const { isLoading, error, companyData } = useFetchCompanyProfile(id);
  const { reviews, loading: reviewsLoading } = useFetchRestaurantReviews(id);
  const offersRef = useRef(null);
  const componentLocation = useLocation()
  
  useEffect(() => { 
    if (companyData && componentLocation.state?.scrollToOffers && offersRef.current) {
      offersRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [companyData, componentLocation.state]);

  if (isLoading || !companyData) {
    return (
      <Loading/>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }


  const displayFlashMessage = (message) => {
    setFlashMessage(message);
    setTimeout(() => {
      setFlashMessage(null);
    }, 3000); 
  };

  return (
    <>
      {flashMessage && (
        <div className="flash-message">
          <p>{flashMessage}</p>
        </div>
      )}
      <div> 
        <div>
          <ProfileCompanyHeader id={id} data={companyData} offersRef={offersRef}/>  
        </div>
        <div className="company-profile__container">
          <div className='company-profile__general-detail-container'>
            <DetailBoxCompany title={'INFORMACIÓN'} data={companyData.information} /> 
            <DetailDeepBoxCompany title={'DESCRIPCIÓN EMPRESA'} data={companyData.description}/> 
          </div>
          <div>
            <BenefitsBoxCompany 
              title={'BENEFICIOS'} 
              data = {[
                "Seguro",
                "Traslado",
                "Uniforme",
                "Capacitaciones",
                "Colación",
                "Formación",
                "Cumpleaños libre",
                "Convenios externos",
                "Descuentos corporativos",
                "Contratos corporativos",
                "Otras"
              ]}
              checkedBenefits={companyData.benefits} 
            /> 
          </div>      
          <div className="company-profile__offers-section" ref={offersRef}>
            <Offers title={'OFERTAS'} data={companyData.jobOffers}/>
          </div> 
          <div className='company-profile__locations-container'>
              <div className="company-profile__locations-box">
                  <h2>DIRECCIONES</h2>
                  <div className="company-profile__location-item">
                      {companyData.locations.map(location => (
                        <div className="company-profile__address-container">
                          <p key={location.id}>{location.address}</p> 
                         </div>
                      ))}
                  </div>
              </div>
              <LocationMap locations={companyData.locations}/>
          </div>
          <div className="">
            <PhotoGallery photoUrls={companyData.profileCarouselUrls}/>
          </div>
          <Reviews reviews={reviews} loading={reviewsLoading} type="restaurant" /> 
        </div>
      </div>
    </>
  );
};

export default CompanyProfile;
